/**
 * Agreement Server
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AuditLog } from '../model/auditLog';
// @ts-ignore
import { DocumentField } from '../model/documentField';
// @ts-ignore
import { ErrorModel } from '../model/errorModel';
// @ts-ignore
import { Job } from '../model/job';
// @ts-ignore
import { JobOfAccessCode } from '../model/jobOfAccessCode';
// @ts-ignore
import { JobOfCode } from '../model/jobOfCode';
// @ts-ignore
import { JobSignatureAudit } from '../model/jobSignatureAudit';
// @ts-ignore
import { JoblistResult } from '../model/joblistResult';
// @ts-ignore
import { MsignResponse } from '../model/msignResponse';
// @ts-ignore
import { Multirequest } from '../model/multirequest';
// @ts-ignore
import { ResponseMessage } from '../model/responseMessage';
// @ts-ignore
import { SmartStatus } from '../model/smartStatus';
// @ts-ignore
import { Template } from '../model/template';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    JobsServiceInterface
} from './jobs.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class JobsService extends BaseService implements JobsServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get the document content of the job of access code
     * @param code Access code
     * @param pass Optional password for the access
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public accesscodesCodeDownloadGet(code: string, pass?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public accesscodesCodeDownloadGet(code: string, pass?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public accesscodesCodeDownloadGet(code: string, pass?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public accesscodesCodeDownloadGet(code: string, pass?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling accesscodesCodeDownloadGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pass, 'pass');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/octet-stream',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/accesscodes/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/download`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the job information with access code
     * @param code Access code for getting infogrmation of the job
     * @param pass Optional password for the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public accesscodesCodeJobGet(code: string, pass?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JobOfAccessCode>;
    public accesscodesCodeJobGet(code: string, pass?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JobOfAccessCode>>;
    public accesscodesCodeJobGet(code: string, pass?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JobOfAccessCode>>;
    public accesscodesCodeJobGet(code: string, pass?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling accesscodesCodeJobGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pass, 'pass');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/accesscodes/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/job`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<JobOfAccessCode>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * AN-1854. The Signing Log for a guest signer, through the completion access code they were sent when the job finished. No access token: most signers have no account. Inherits the completion code\&#39;s existing expiry window, and is refused once it lapses. The validation code printed on the signed document is NOT accepted here, and this is deliberate: it has a years-long lifetime, and the Signing Log carries every signer\&#39;s name, e-mail, IP address and user agent. The job\&#39;s &#x60;downloadFromValidation&#x60; flag — which does open the *document* to that code — has no effect on this endpoint.
     * @param code Completion access code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public accesscodesCodeSigningLogGet(code: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public accesscodesCodeSigningLogGet(code: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public accesscodesCodeSigningLogGet(code: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public accesscodesCodeSigningLogGet(code: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling accesscodesCodeSigningLogGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/accesscodes/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/signinglog`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Prepare jobs to sign.
     * @param accessToken Access Token
     * @param jobs Comma delimited job id list
     * @param recipient1Name Name of the first recipient
     * @param recipient1Email Email of the first recipient
     * @param orderNo1 Order for first recipient
     * @param recipient2Name Name of the second recipient
     * @param recipient2Email Email of the second recipient
     * @param orderNo2 Order for second recipient
     * @param recipient3Name Name of the third recipient
     * @param recipient3Email Email of the third recipient
     * @param orderNo3 Order for third recipient
     * @param recipient4Name Name of the fourth recipient
     * @param recipient4Email Email of the fourth recipient
     * @param orderNo4 Order for fourth recipient
     * @param recipient5Name Name of the fifth recipient
     * @param recipient5Email Email of the fifth recipient
     * @param orderNo5 Order for fifth recipient
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsActionsMultipreparePost(accessToken: string, jobs: string, recipient1Name: string, recipient1Email: string, orderNo1?: string, recipient2Name?: string, recipient2Email?: string, orderNo2?: string, recipient3Name?: string, recipient3Email?: string, orderNo3?: string, recipient4Name?: string, recipient4Email?: string, orderNo4?: string, recipient5Name?: string, recipient5Email?: string, orderNo5?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Multirequest>>;
    public jobsActionsMultipreparePost(accessToken: string, jobs: string, recipient1Name: string, recipient1Email: string, orderNo1?: string, recipient2Name?: string, recipient2Email?: string, orderNo2?: string, recipient3Name?: string, recipient3Email?: string, orderNo3?: string, recipient4Name?: string, recipient4Email?: string, orderNo4?: string, recipient5Name?: string, recipient5Email?: string, orderNo5?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Multirequest>>>;
    public jobsActionsMultipreparePost(accessToken: string, jobs: string, recipient1Name: string, recipient1Email: string, orderNo1?: string, recipient2Name?: string, recipient2Email?: string, orderNo2?: string, recipient3Name?: string, recipient3Email?: string, orderNo3?: string, recipient4Name?: string, recipient4Email?: string, orderNo4?: string, recipient5Name?: string, recipient5Email?: string, orderNo5?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Multirequest>>>;
    public jobsActionsMultipreparePost(accessToken: string, jobs: string, recipient1Name: string, recipient1Email: string, orderNo1?: string, recipient2Name?: string, recipient2Email?: string, orderNo2?: string, recipient3Name?: string, recipient3Email?: string, orderNo3?: string, recipient4Name?: string, recipient4Email?: string, orderNo4?: string, recipient5Name?: string, recipient5Email?: string, orderNo5?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsActionsMultipreparePost.');
        }
        if (jobs === null || jobs === undefined) {
            throw new Error('Required parameter jobs was null or undefined when calling jobsActionsMultipreparePost.');
        }
        if (recipient1Name === null || recipient1Name === undefined) {
            throw new Error('Required parameter recipient1Name was null or undefined when calling jobsActionsMultipreparePost.');
        }
        if (recipient1Email === null || recipient1Email === undefined) {
            throw new Error('Required parameter recipient1Email was null or undefined when calling jobsActionsMultipreparePost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (jobs !== undefined && jobs !== null) {
            localVarFormParams = localVarFormParams.append('jobs', <any>jobs) as any || localVarFormParams;
        }
        if (recipient1Name !== undefined && recipient1Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient1Name', <any>recipient1Name) as any || localVarFormParams;
        }
        if (recipient1Email !== undefined && recipient1Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient1Email', <any>recipient1Email) as any || localVarFormParams;
        }
        if (orderNo1 !== undefined && orderNo1 !== null) {
            localVarFormParams = localVarFormParams.append('orderNo1', <any>orderNo1) as any || localVarFormParams;
        }
        if (recipient2Name !== undefined && recipient2Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient2Name', <any>recipient2Name) as any || localVarFormParams;
        }
        if (recipient2Email !== undefined && recipient2Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient2Email', <any>recipient2Email) as any || localVarFormParams;
        }
        if (orderNo2 !== undefined && orderNo2 !== null) {
            localVarFormParams = localVarFormParams.append('orderNo2', <any>orderNo2) as any || localVarFormParams;
        }
        if (recipient3Name !== undefined && recipient3Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient3Name', <any>recipient3Name) as any || localVarFormParams;
        }
        if (recipient3Email !== undefined && recipient3Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient3Email', <any>recipient3Email) as any || localVarFormParams;
        }
        if (orderNo3 !== undefined && orderNo3 !== null) {
            localVarFormParams = localVarFormParams.append('orderNo3', <any>orderNo3) as any || localVarFormParams;
        }
        if (recipient4Name !== undefined && recipient4Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient4Name', <any>recipient4Name) as any || localVarFormParams;
        }
        if (recipient4Email !== undefined && recipient4Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient4Email', <any>recipient4Email) as any || localVarFormParams;
        }
        if (orderNo4 !== undefined && orderNo4 !== null) {
            localVarFormParams = localVarFormParams.append('orderNo4', <any>orderNo4) as any || localVarFormParams;
        }
        if (recipient5Name !== undefined && recipient5Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient5Name', <any>recipient5Name) as any || localVarFormParams;
        }
        if (recipient5Email !== undefined && recipient5Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient5Email', <any>recipient5Email) as any || localVarFormParams;
        }
        if (orderNo5 !== undefined && orderNo5 !== null) {
            localVarFormParams = localVarFormParams.append('orderNo5', <any>orderNo5) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/actions/multiprepare`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Multirequest>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Archive given jobs
     * @param accessToken System access token
     * @param jobs comma separated job ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsBulkactionsArchivePut(accessToken: string, jobs: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsBulkactionsArchivePut(accessToken: string, jobs: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsBulkactionsArchivePut(accessToken: string, jobs: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsBulkactionsArchivePut(accessToken: string, jobs: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsBulkactionsArchivePut.');
        }
        if (jobs === null || jobs === undefined) {
            throw new Error('Required parameter jobs was null or undefined when calling jobsBulkactionsArchivePut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (jobs !== undefined && jobs !== null) {
            localVarFormParams = localVarFormParams.append('jobs', <any>jobs) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/bulkactions/archive`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete given jobs
     * @param accessToken System access token
     * @param jobs comma separated job ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsBulkactionsDeleteDelete(accessToken: string, jobs: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsBulkactionsDeleteDelete(accessToken: string, jobs: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsBulkactionsDeleteDelete(accessToken: string, jobs: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsBulkactionsDeleteDelete(accessToken: string, jobs: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsBulkactionsDeleteDelete.');
        }
        if (jobs === null || jobs === undefined) {
            throw new Error('Required parameter jobs was null or undefined when calling jobsBulkactionsDeleteDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (jobs !== undefined && jobs !== null) {
            localVarFormParams = localVarFormParams.append('jobs', <any>jobs) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/bulkactions/delete`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete given templates
     * @param accessToken System access token
     * @param templates comma seperated template ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsBulkactionsDeletetemplateDelete(accessToken: string, templates: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsBulkactionsDeletetemplateDelete(accessToken: string, templates: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsBulkactionsDeletetemplateDelete(accessToken: string, templates: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsBulkactionsDeletetemplateDelete(accessToken: string, templates: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsBulkactionsDeletetemplateDelete.');
        }
        if (templates === null || templates === undefined) {
            throw new Error('Required parameter templates was null or undefined when calling jobsBulkactionsDeletetemplateDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (templates !== undefined && templates !== null) {
            localVarFormParams = localVarFormParams.append('templates', <any>templates) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/bulkactions/deletetemplate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Move given jobs to Inbox
     * @param accessToken System access token
     * @param jobs comma separated job ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsBulkactionsMovetoinboxPut(accessToken: string, jobs: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsBulkactionsMovetoinboxPut(accessToken: string, jobs: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsBulkactionsMovetoinboxPut(accessToken: string, jobs: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsBulkactionsMovetoinboxPut(accessToken: string, jobs: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsBulkactionsMovetoinboxPut.');
        }
        if (jobs === null || jobs === undefined) {
            throw new Error('Required parameter jobs was null or undefined when calling jobsBulkactionsMovetoinboxPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (jobs !== undefined && jobs !== null) {
            localVarFormParams = localVarFormParams.append('jobs', <any>jobs) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/bulkactions/movetoinbox`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new CADES signing job for the user. Starts the job process for ME_OTHERS, adds the given document to the job, sets single recipient and starts the job. The job is completed when the recipient signs the document.
     * @param accessToken System access token
     * @param cadesType CADES Signature Type: ENVELOPING, DETACHED
     * @param name Job Name
     * @param recipientName Recipient Name
     * @param recipientEmail Recipient Email
     * @param document Document to be signed in base64 encoding
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsCadesPost(accessToken: string, cadesType: string, name: string, recipientName: string, recipientEmail: string, document: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsCadesPost(accessToken: string, cadesType: string, name: string, recipientName: string, recipientEmail: string, document: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsCadesPost(accessToken: string, cadesType: string, name: string, recipientName: string, recipientEmail: string, document: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsCadesPost(accessToken: string, cadesType: string, name: string, recipientName: string, recipientEmail: string, document: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsCadesPost.');
        }
        if (cadesType === null || cadesType === undefined) {
            throw new Error('Required parameter cadesType was null or undefined when calling jobsCadesPost.');
        }
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling jobsCadesPost.');
        }
        if (recipientName === null || recipientName === undefined) {
            throw new Error('Required parameter recipientName was null or undefined when calling jobsCadesPost.');
        }
        if (recipientEmail === null || recipientEmail === undefined) {
            throw new Error('Required parameter recipientEmail was null or undefined when calling jobsCadesPost.');
        }
        if (document === null || document === undefined) {
            throw new Error('Required parameter document was null or undefined when calling jobsCadesPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (cadesType !== undefined && cadesType !== null) {
            localVarFormParams = localVarFormParams.append('cades_type', <any>cadesType) as any || localVarFormParams;
        }
        if (name !== undefined && name !== null) {
            localVarFormParams = localVarFormParams.append('name', <any>name) as any || localVarFormParams;
        }
        if (recipientName !== undefined && recipientName !== null) {
            localVarFormParams = localVarFormParams.append('recipient_name', <any>recipientName) as any || localVarFormParams;
        }
        if (recipientEmail !== undefined && recipientEmail !== null) {
            localVarFormParams = localVarFormParams.append('recipient_email', <any>recipientEmail) as any || localVarFormParams;
        }
        if (document !== undefined && document !== null) {
            localVarFormParams = localVarFormParams.append('document', <any>document) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/cades`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new jobs using existing job template and fill the empty fields using uploaded CSV file and prepare the jobs to sign.
     * @param accessToken System access token
     * @param templateId ID of the job template
     * @param recipient1Id ID of the first recipient
     * @param file CSV File data
     * @param recipient2Id ID of the second recipient
     * @param recipient3Id ID of the third recipient
     * @param recipient4Id ID of the fourth recipient
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsCsvPost(accessToken: string, templateId: string, recipient1Id: string, file: Blob, recipient2Id?: string, recipient3Id?: string, recipient4Id?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsCsvPost(accessToken: string, templateId: string, recipient1Id: string, file: Blob, recipient2Id?: string, recipient3Id?: string, recipient4Id?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsCsvPost(accessToken: string, templateId: string, recipient1Id: string, file: Blob, recipient2Id?: string, recipient3Id?: string, recipient4Id?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsCsvPost(accessToken: string, templateId: string, recipient1Id: string, file: Blob, recipient2Id?: string, recipient3Id?: string, recipient4Id?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsCsvPost.');
        }
        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling jobsCsvPost.');
        }
        if (recipient1Id === null || recipient1Id === undefined) {
            throw new Error('Required parameter recipient1Id was null or undefined when calling jobsCsvPost.');
        }
        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling jobsCsvPost.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>templateId, 'template_id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>recipient1Id, 'recipient1Id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>recipient2Id, 'recipient2Id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>recipient3Id, 'recipient3Id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>recipient4Id, 'recipient4Id');

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (file !== undefined && file !== null) {
            localVarFormParams = localVarFormParams.append('file', <any>file) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/csv`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all jobs of the user
     * @param accessToken System access token
     * @param keywords Search keyword for job name and tags
     * @param sorting Sorting criteria.Values: modification|creation|name
     * @param status Status criteria. Values: ALL|DRAFT|IN_PROGRESS|DECLINED|SIGNED|COMPLETED
     * @param smartstatus Smart status criteria. Values: none|waitingme|waitingothers|completed|myjobs
     * @param folder Folder criteria. Values: ALL|INBOX|ARCHIVE
     * @param tag Tag criteria. Filters the jobs with exact tag
     * @param start Start point of the results. Default: 0
     * @param limit limit of the results. Default: 20
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsGet(accessToken: string, keywords?: string, sorting?: string, status?: string, smartstatus?: string, folder?: string, tag?: string, start?: string, limit?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JoblistResult>;
    public jobsGet(accessToken: string, keywords?: string, sorting?: string, status?: string, smartstatus?: string, folder?: string, tag?: string, start?: string, limit?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JoblistResult>>;
    public jobsGet(accessToken: string, keywords?: string, sorting?: string, status?: string, smartstatus?: string, folder?: string, tag?: string, start?: string, limit?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JoblistResult>>;
    public jobsGet(accessToken: string, keywords?: string, sorting?: string, status?: string, smartstatus?: string, folder?: string, tag?: string, start?: string, limit?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>keywords, 'keywords');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sorting, 'sorting');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>status, 'status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>smartstatus, 'smartstatus');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>folder, 'folder');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>tag, 'tag');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>start, 'start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>limit, 'limit');

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<JoblistResult>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Combine multiple uploaded documents of a job into a single PDF document.  **What this action does:** - Merges all specified documents into a single PDF in the given order - Creates a new combined document entry in the database - Deletes all original individual documents (both from database and storage) - Preserves the form design (fields) from the first document in the list  **Prerequisites:** - Job must be in NONE or DRAFT status - All document IDs must belong to the specified job - Documents must not be encrypted  **Combined document properties:** - Location: Uses the first document\&#39;s location path - Name: Uses the first document\&#39;s base filename - Form Design: Inherits from the first document - Page count: Sum of all pages from merged documents  **Size validation:** - Combined PDF size is validated against system limits - If the combined size exceeds the limit, the operation fails and original documents are preserved  **Access control:** - Job owner can combine documents - Team members with access to the job owner\&#39;s jobs can also combine documents 
     * @param accessToken User access token for authentication
     * @param id ID of the job containing the documents to combine
     * @param documents Comma-separated list of document IDs specifying the order of combination. Example: \\\&quot;101,102,103\\\&quot; will merge document 101 first, then 102, then 103. All IDs must belong to documents in the specified job. 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdActionsCombinePut(accessToken: string, id: number, documents: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdActionsCombinePut(accessToken: string, id: number, documents: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdActionsCombinePut(accessToken: string, id: number, documents: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdActionsCombinePut(accessToken: string, id: number, documents: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdActionsCombinePut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdActionsCombinePut.');
        }
        if (documents === null || documents === undefined) {
            throw new Error('Required parameter documents was null or undefined when calling jobsIdActionsCombinePut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (documents !== undefined && documents !== null) {
            localVarFormParams = localVarFormParams.append('documents', <any>documents) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/actions/combine`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Finish the job and send signature requests to all recipients.  **What this action does:** - Changes job status from DRAFT to IN_PROGRESS - Generates unique recipient codes for each recipient - Sends email notifications to all recipients (if enabled) - Generates PDFs with embedded form fields (if fields were set) - Locks the recipient list (no more recipients can be added/removed)  **Important Notes:** - This operation may take up to 45 seconds for jobs with many recipients or complex form fields - After calling this endpoint, recipients receive their unique codes via email - To retrieve a recipient\&#39;s code programmatically, use GET /recipient_requests?recipient_id&#x3D;{recipient_id} - Each recipient can use their code to access and sign the document via recipient_requests endpoints  **EYP jobs (signing_type&#x3D;EYP):** finish assembles the OPC package one-shot from the draft (üstveri + üst yazı + ekler + dağıtım + ilgi), runs completeness checks, **freezes** the package (eyp_state DRAFT→SIGNING; further mutating calls &#x3D;&gt; EYP_PACKAGE_FROZEN, except belgeNo/tarih), and dispatches signing requests. Signatures are CAdES over PaketÖzeti (never over a PDF). After all signatures reach X-Long evidence the job parks at AWAITING_SEAL (eyp_state SIGNING→EVIDENCE_PENDING →AWAITING_SEAL); the e-seal recipient\&#39;s step (Phase 3) then completes it. Signing while evidence is still pending &#x3D;&gt; EYP_EVIDENCE_PENDING (retryable). (Phase 2)  **Response includes:** - Job object with status &#x3D; IN_PROGRESS - Recipients array (without codes - codes must be retrieved separately) - Updated document with embedded form fields (if applicable) 
     * @param accessToken System access token
     * @param id ID of the job
     * @param subject subject of the message
     * @param message body of the message
     * @param validationStamp validation stamp option for enterprise plan only
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdActionsFinishPut(accessToken: string, id: number, subject?: string, message?: string, validationStamp?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdActionsFinishPut(accessToken: string, id: number, subject?: string, message?: string, validationStamp?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdActionsFinishPut(accessToken: string, id: number, subject?: string, message?: string, validationStamp?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdActionsFinishPut(accessToken: string, id: number, subject?: string, message?: string, validationStamp?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdActionsFinishPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdActionsFinishPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (subject !== undefined && subject !== null) {
            localVarFormParams = localVarFormParams.append('subject', <any>subject) as any || localVarFormParams;
        }
        if (message !== undefined && message !== null) {
            localVarFormParams = localVarFormParams.append('message', <any>message) as any || localVarFormParams;
        }
        if (validationStamp !== undefined && validationStamp !== null) {
            localVarFormParams = localVarFormParams.append('validationStamp', <any>validationStamp) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/actions/finish`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Save the job
     * @param accessToken System access token
     * @param id ID of the job
     * @param subject Subject of the message
     * @param message Body of the message
     * @param validationStamp Validation stamp option for enterprise plan only
     * @param validationAreaBottomMargin Distance from bottom edge of the first page for validation stamp
     * @param validationStampLegalText Option for removing first-page legal text from validation stamp. true: keep, false: remove and use QR code instead as other pages
     * @param qrCodeXMargin Distance from left edge of pages for QR codes
     * @param qrCodeYMargin Distance from bottom edge of pages for QR codes
     * @param downloadFromValidation Option for enabling download in the validation screen
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdActionsSavePut(accessToken: string, id: number, subject?: string, message?: string, validationStamp?: string, validationAreaBottomMargin?: string, validationStampLegalText?: string, qrCodeXMargin?: string, qrCodeYMargin?: string, downloadFromValidation?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdActionsSavePut(accessToken: string, id: number, subject?: string, message?: string, validationStamp?: string, validationAreaBottomMargin?: string, validationStampLegalText?: string, qrCodeXMargin?: string, qrCodeYMargin?: string, downloadFromValidation?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdActionsSavePut(accessToken: string, id: number, subject?: string, message?: string, validationStamp?: string, validationAreaBottomMargin?: string, validationStampLegalText?: string, qrCodeXMargin?: string, qrCodeYMargin?: string, downloadFromValidation?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdActionsSavePut(accessToken: string, id: number, subject?: string, message?: string, validationStamp?: string, validationAreaBottomMargin?: string, validationStampLegalText?: string, qrCodeXMargin?: string, qrCodeYMargin?: string, downloadFromValidation?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdActionsSavePut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdActionsSavePut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (subject !== undefined && subject !== null) {
            localVarFormParams = localVarFormParams.append('subject', <any>subject) as any || localVarFormParams;
        }
        if (message !== undefined && message !== null) {
            localVarFormParams = localVarFormParams.append('message', <any>message) as any || localVarFormParams;
        }
        if (validationStamp !== undefined && validationStamp !== null) {
            localVarFormParams = localVarFormParams.append('validationStamp', <any>validationStamp) as any || localVarFormParams;
        }
        if (validationAreaBottomMargin !== undefined && validationAreaBottomMargin !== null) {
            localVarFormParams = localVarFormParams.append('validationAreaBottomMargin', <any>validationAreaBottomMargin) as any || localVarFormParams;
        }
        if (validationStampLegalText !== undefined && validationStampLegalText !== null) {
            localVarFormParams = localVarFormParams.append('validationStampLegalText', <any>validationStampLegalText) as any || localVarFormParams;
        }
        if (qrCodeXMargin !== undefined && qrCodeXMargin !== null) {
            localVarFormParams = localVarFormParams.append('qrCodeXMargin', <any>qrCodeXMargin) as any || localVarFormParams;
        }
        if (qrCodeYMargin !== undefined && qrCodeYMargin !== null) {
            localVarFormParams = localVarFormParams.append('qrCodeYMargin', <any>qrCodeYMargin) as any || localVarFormParams;
        }
        if (downloadFromValidation !== undefined && downloadFromValidation !== null) {
            localVarFormParams = localVarFormParams.append('downloadFromValidation', <any>downloadFromValidation) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/actions/save`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Send the signed document to email recipients as attachment. Recipients and owner can share with their own job names. Emails are sent in a queue so the response will not wait for all sent.
     * @param accessToken System access token
     * @param id Job ID
     * @param emails Email addresses with comma separated. Email addresses can alseo be in form of \\\&#39;Victor Hugo &lt;victor_hugo@gmail.com&gt;\\\&#39;.
     * @param message Message content to be used in email message. Default multilanguage (language of the recipient) content is used if message is empty.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdActionsShareattachmentPost(accessToken: string, id: string, emails: string, message?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsIdActionsShareattachmentPost(accessToken: string, id: string, emails: string, message?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsIdActionsShareattachmentPost(accessToken: string, id: string, emails: string, message?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsIdActionsShareattachmentPost(accessToken: string, id: string, emails: string, message?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdActionsShareattachmentPost.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdActionsShareattachmentPost.');
        }
        if (emails === null || emails === undefined) {
            throw new Error('Required parameter emails was null or undefined when calling jobsIdActionsShareattachmentPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (emails !== undefined && emails !== null) {
            localVarFormParams = localVarFormParams.append('emails', <any>emails) as any || localVarFormParams;
        }
        if (message !== undefined && message !== null) {
            localVarFormParams = localVarFormParams.append('message', <any>message) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/actions/shareattachment`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start request signature process for ME_OTHERS type jobs (multiple recipients).  **What this action does:** - Changes job status from NONE to DRAFT - Sets job type to ME_OTHERS - Automatically adds the requesting user as the first recipient (SIGNER role, REQUIRED workflow_effect) - Enables adding/removing additional recipients - Allows configuring recipient workflow order  **Workflow - Multiple Recipients (ME_OTHERS):** 1. Create job: POST /jobs 2. Add documents: POST /jobs/{id}/documents 3. **Start request signature: PUT /jobs/{id}/actions/startrequestsignature** (this endpoint)    - User becomes first recipient    - Job enters DRAFT status    - Ready to add more recipients 4. Add/manage recipients:    - Add recipients: POST /jobs/{id}/recipients    - Update recipient: PUT /recipients/{id}    - Delete recipient: DELETE /recipients/{id}    - Set recipient order: PUT /jobs/{id}/recipients (with recipientOrder parameter) 5. Add signature fields: POST /jobs/{id}/documents/{document_id}/fields 6. Finish: PUT /jobs/{id}/actions/finish  **Prerequisites:** - Job must have at least one document - Job status must be NONE  **Use Case:** Use this action when multiple people need to sign or review the documents. After calling this endpoint, you can add other recipients and configure their roles (SIGNER, VIEWER, COPY) and workflow effects (REQUIRED, OPTIONAL).  **Important Notes:** - The user who calls this endpoint is automatically added as the first recipient - Recipients can only be added/removed while job is in DRAFT status - Once you call PUT /jobs/{id}/actions/finish, no more recipients can be added 
     * @param accessToken System access token
     * @param id ID of the job
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdActionsStartrequestsignaturePut(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdActionsStartrequestsignaturePut(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdActionsStartrequestsignaturePut(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdActionsStartrequestsignaturePut(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdActionsStartrequestsignaturePut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdActionsStartrequestsignaturePut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/actions/startrequestsignature`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start self signing process for SELF type jobs.  **What this action does:** - Changes job status from NONE to IN_PROGRESS - Sets job type to SELF - Automatically adds the requesting user as the only recipient (SIGNER role, REQUIRED workflow_effect) - No additional recipients can be added after this action  **Workflow - Self Signing:** 1. Create job: POST /jobs 2. Add documents: POST /jobs/{id}/documents 3. **Start self signing: PUT /jobs/{id}/actions/startself** (this endpoint)    - User becomes the only signer    - No more recipients can be added 4. Add signature fields: POST /jobs/{id}/documents/{document_id}/fields 5. Finish: PUT /jobs/{id}/actions/finish  **Prerequisites:** - Job must have at least one document - Job status must be NONE  **Use Case:** Use this action when the user wants to sign their own documents without involving other recipients. 
     * @param accessToken System access token
     * @param id ID of the job
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdActionsStartselfPut(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdActionsStartselfPut(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdActionsStartselfPut(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdActionsStartselfPut(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdActionsStartselfPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdActionsStartselfPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/actions/startself`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get signatures of audit for job
     * @param accessToken System access token
     * @param id ID of the job
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdAuditSignaturesGet(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<JobSignatureAudit>>;
    public jobsIdAuditSignaturesGet(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<JobSignatureAudit>>>;
    public jobsIdAuditSignaturesGet(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<JobSignatureAudit>>>;
    public jobsIdAuditSignaturesGet(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdAuditSignaturesGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdAuditSignaturesGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/audit_signatures`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<JobSignatureAudit>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete given job with all documents an recipients
     * @param accessToken System access token
     * @param id id of the job
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdDelete(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsIdDelete(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsIdDelete(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsIdDelete(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdDelete.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete all temporary documents (other than the first one) of the job
     * @param accessToken System access token
     * @param id ID of the job
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdDocumentsDelete(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdDocumentsDelete(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdDocumentsDelete(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdDocumentsDelete(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdDocumentsDelete.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdDocumentsDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/documents`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the specified job of the user
     * @param accessToken System access token
     * @param id ID of the job
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdGet(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdGet(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdGet(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdGet(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Provides job history
     * @param accessToken System access token
     * @param id Job ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdHistoryGet(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<AuditLog>>;
    public jobsIdHistoryGet(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<AuditLog>>>;
    public jobsIdHistoryGet(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<AuditLog>>>;
    public jobsIdHistoryGet(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdHistoryGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdHistoryGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/history`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<AuditLog>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Move job to archive if the user is owner or a recipient
     * @param accessToken System access token
     * @param id Job ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdMovetoarchivePut(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdMovetoarchivePut(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdMovetoarchivePut(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdMovetoarchivePut(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdMovetoarchivePut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdMovetoarchivePut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/movetoarchive`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Move job to inbox if the user is owner or a recipient
     * @param accessToken System access token
     * @param id Job ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdMovetoinboxPut(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdMovetoinboxPut(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdMovetoinboxPut(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdMovetoinboxPut(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdMovetoinboxPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdMovetoinboxPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/movetoinbox`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update job for the owner or recipient. On update, all current tags are removed and new tags are added. Updated name and tags are dedicated to the updater user (owner or recipient) independent from others.
     * @param accessToken System access token
     * @param id ID of the job
     * @param tags Tag list separated by comma
     * @param name Job name
     * @param sufficientNotification Boolean for sending notification to recipients
     * @param sufficientClosePeriod Time that the system waits before the document is closed
     * @param mailNotifications AN-1806: per-job email switch (true/false). When false, all three signer email notifications (signing request, signer-signed, signing completed) are suppressed for the job; when true (default) they are sent. Settable after create so it can be toggled. The current value is returned on the job model as mailNotifications.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdPut(accessToken: string, id: number, tags?: string, name?: string, sufficientNotification?: string, sufficientClosePeriod?: string, mailNotifications?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdPut(accessToken: string, id: number, tags?: string, name?: string, sufficientNotification?: string, sufficientClosePeriod?: string, mailNotifications?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdPut(accessToken: string, id: number, tags?: string, name?: string, sufficientNotification?: string, sufficientClosePeriod?: string, mailNotifications?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdPut(accessToken: string, id: number, tags?: string, name?: string, sufficientNotification?: string, sufficientClosePeriod?: string, mailNotifications?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (tags !== undefined && tags !== null) {
            localVarFormParams = localVarFormParams.append('tags', <any>tags) as any || localVarFormParams;
        }
        if (name !== undefined && name !== null) {
            localVarFormParams = localVarFormParams.append('name', <any>name) as any || localVarFormParams;
        }
        if (sufficientNotification !== undefined && sufficientNotification !== null) {
            localVarFormParams = localVarFormParams.append('sufficient_notification', <any>sufficientNotification) as any || localVarFormParams;
        }
        if (sufficientClosePeriod !== undefined && sufficientClosePeriod !== null) {
            localVarFormParams = localVarFormParams.append('sufficient_close_period', <any>sufficientClosePeriod) as any || localVarFormParams;
        }
        if (mailNotifications !== undefined && mailNotifications !== null) {
            localVarFormParams = localVarFormParams.append('mail_notifications', <any>mailNotifications) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Add a new recipient to a job with multiple recipients.  **Prerequisites:** - Job status must be DRAFT - Job type must be ME_OTHERS - Must call PUT /jobs/{id}/actions/startrequestsignature first to prepare the job  **Workflow Context:** This endpoint is step 4 in the ME_OTHERS workflow: 1. Create job: POST /jobs 2. Add documents: POST /jobs/{id}/documents 3. Start request signature: PUT /jobs/{id}/actions/startrequestsignature 4. **Add recipients: POST /jobs/{id}/recipients** (this endpoint) 5. Optionally update recipients: PUT /recipients/{id} 6. Add signature fields and finish  **Default Behavior:** - Role is automatically set to SIGNER during creation (role parameter is ignored) - workflow_effect is automatically set to REQUIRED during creation - Use PUT /recipients/{id} to change role to VIEWER or COPY after creation - Use PUT /recipients/{id} to change workflow_effect to OPTIONAL after creation  **Recipient Roles:** - SIGNER: Can sign documents (default) - VIEWER: Can view documents but not sign - COPY: Receives copy of completed documents  **Workflow Effects:** - REQUIRED: Recipient must complete their action for workflow to proceed (default) - OPTIONAL: Workflow can proceed without this recipient\&#39;s action  **Validation:** - Name is required and cannot be empty - Email is required and must be valid - Email must be unique within the job (no duplicate recipients) - Citizen ID must be exactly 11 digits if provided 
     * @param accessToken System access token
     * @param id Job ID
     * @param name Recipient full name
     * @param email Recipient email
     * @param citizenId Citizen ID (must be exactly 11 digits)
     * @param role Recipient role. signer, viewer, copy
     * @param workflowEffect Recipient worklow effect. required, optional
     * @param orderno Recipient order no. If not given, the default is 1
     * @param phoneNumber Recipient phone number (for SMS verification)
     * @param smsCountryCode Recipient phone number country code (for SMS verification)
     * @param signMethod Explicit signing method. One of qes (qualified e-signature), bio (biometric), initials. If omitted, signing falls back to widget inference (legacy).
     * @param canCustomizeSignBox AN-1801: when true, this QES signer places/customizes their own single signature box during signing (the sender may not place it). Accepted only for role SIGNER with sign_method qes; otherwise 400 (302). Sent as boolean true/false.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdRecipientsPost(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, orderno?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdRecipientsPost(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, orderno?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdRecipientsPost(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, orderno?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdRecipientsPost(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, orderno?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdRecipientsPost.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdRecipientsPost.');
        }
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling jobsIdRecipientsPost.');
        }
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling jobsIdRecipientsPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (name !== undefined && name !== null) {
            localVarFormParams = localVarFormParams.append('name', <any>name) as any || localVarFormParams;
        }
        if (email !== undefined && email !== null) {
            localVarFormParams = localVarFormParams.append('email', <any>email) as any || localVarFormParams;
        }
        if (citizenId !== undefined && citizenId !== null) {
            localVarFormParams = localVarFormParams.append('citizen_id', <any>citizenId) as any || localVarFormParams;
        }
        if (role !== undefined && role !== null) {
            localVarFormParams = localVarFormParams.append('role', <any>role) as any || localVarFormParams;
        }
        if (workflowEffect !== undefined && workflowEffect !== null) {
            localVarFormParams = localVarFormParams.append('workflow_effect', <any>workflowEffect) as any || localVarFormParams;
        }
        if (orderno !== undefined && orderno !== null) {
            localVarFormParams = localVarFormParams.append('orderno', <any>orderno) as any || localVarFormParams;
        }
        if (phoneNumber !== undefined && phoneNumber !== null) {
            localVarFormParams = localVarFormParams.append('phone_number', <any>phoneNumber) as any || localVarFormParams;
        }
        if (smsCountryCode !== undefined && smsCountryCode !== null) {
            localVarFormParams = localVarFormParams.append('sms_country_code', <any>smsCountryCode) as any || localVarFormParams;
        }
        if (signMethod !== undefined && signMethod !== null) {
            localVarFormParams = localVarFormParams.append('sign_method', <any>signMethod) as any || localVarFormParams;
        }
        if (canCustomizeSignBox !== undefined && canCustomizeSignBox !== null) {
            localVarFormParams = localVarFormParams.append('can_customize_sign_box', <any>canCustomizeSignBox) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/recipients`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Configure the signing workflow order for recipients.  **Workflow Context:** This endpoint is used after adding multiple recipients to define their signing sequence: 1. Start request signature: PUT /jobs/{id}/actions/startrequestsignature 2. Add recipients: POST /jobs/{id}/recipients (multiple times) 3. **Set recipient order: PUT /jobs/{id}/recipients** (this endpoint) 4. Add fields and finish  **Recipient Order Format:** - Sequential steps are separated by \&quot;|\&quot; (pipe) - Parallel recipients (same step) are separated by \&quot;,\&quot; (comma) - Example: \&quot;123,456|789|101,102,103\&quot;   - Step 1: Recipients 123 and 456 sign in parallel   - Step 2: Recipient 789 signs after step 1 completes   - Step 3: Recipients 101, 102, and 103 sign in parallel after step 2  **Prerequisites:** - Job must be in DRAFT status - All recipient IDs in the order string must exist and belong to the job - User must be the job owner  **Workflow Effects:** - Recipients marked as REQUIRED must complete their action before the workflow proceeds to the next step - Recipients marked as OPTIONAL can be skipped without blocking the workflow - Parallel recipients in the same step can sign in any order  **Common Use Cases:** - Define approval chain: Manager → Director → CEO - Set up parallel signing: Multiple team members sign simultaneously - Create hybrid workflows: Parallel approvals followed by final sequential signature 
     * @param accessToken System access token
     * @param id Job ID
     * @param recipientOrder Recipient order with list of recipient IDs. Sequence is separated by \\\&quot;|\\\&quot; and parallel recipients are separated with \\\&quot;,\\\&quot;. i.e: 4432,334|556,566,998|432|1123 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdRecipientsPut(accessToken: string, id: number, recipientOrder: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdRecipientsPut(accessToken: string, id: number, recipientOrder: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdRecipientsPut(accessToken: string, id: number, recipientOrder: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdRecipientsPut(accessToken: string, id: number, recipientOrder: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdRecipientsPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdRecipientsPut.');
        }
        if (recipientOrder === null || recipientOrder === undefined) {
            throw new Error('Required parameter recipientOrder was null or undefined when calling jobsIdRecipientsPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (recipientOrder !== undefined && recipientOrder !== null) {
            localVarFormParams = localVarFormParams.append('recipientOrder', <any>recipientOrder) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/recipients`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * AN-1854. The Signing Log for a completed job: a PDF recording the whole ceremony — the document and its completion-time digest, the sender, every signer with how they were authenticated and what they accepted, the chronological audit trail, and the accepted disclosure text appended verbatim. Available to the sender, their team members, and any registered recipient of the job. A guest signer uses &#x60;/accesscodes/{code}/signinglog&#x60; instead. Generated on first request and cached; PAdES jobs only. A job that is not COMPLETED, or is CAdES or EYP, answers 400 with code 244.
     * @param accessToken System access token
     * @param id Job ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdSigningLogGet(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public jobsIdSigningLogGet(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public jobsIdSigningLogGet(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public jobsIdSigningLogGet(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdSigningLogGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdSigningLogGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/signinglog`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * update job with existing template
     * @param accessToken System access token
     * @param id ID of the job
     * @param templateId ID of the template job
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsIdTemplateTemplateIdPut(accessToken: string, id: number, templateId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsIdTemplateTemplateIdPut(accessToken: string, id: number, templateId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsIdTemplateTemplateIdPut(accessToken: string, id: number, templateId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsIdTemplateTemplateIdPut(accessToken: string, id: number, templateId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsIdTemplateTemplateIdPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsIdTemplateTemplateIdPut.');
        }
        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling jobsIdTemplateTemplateIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/template/${this.configuration.encodeParam({name: "templateId", value: templateId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new job for the user. Job is created with status&#x3D;NONE and type&#x3D;SELF by default.  **Workflow for ME_OTHERS (multiple recipients):** 1. Create job (this endpoint) 2. Add documents: POST /jobs/{id}/documents 3. Start request signature: PUT /jobs/{id}/actions/startrequestsignature    - Changes type to ME_OTHERS, status to DRAFT    - Adds user as default recipient 4. Add/remove recipients: POST /jobs/{id}/recipients, DELETE /recipients/{id} 5. Add signature fields 6. Finish  **Workflow for SELF (self-signing):** 1. Create job (this endpoint) 2. Add documents: POST /jobs/{id}/documents 3. Start self signing: PUT /jobs/{id}/actions/startself    - Adds user as default recipient    - No more recipients can be added 4. Add signature fields 5. Finish 
     * @param accessToken System access token
     * @param name Job name
     * @param signingType Optional. Set to EYP to create an e-Yazışma (EYP) draft job instead of the default SELF job: the job is created with signature&#x3D;EYP, type&#x3D;ME_OTHERS, status&#x3D;DRAFT and eyp_state&#x3D;DRAFT. Requires the &#x60;eyp&#x60; block and a plan with EYP support (canUserUseEyp); imzayeri brand only. (Phase 2)
     * @param eyp JSON eypBlock — required when signing_type&#x3D;EYP (rehberVersion, konu, guvenlikKodu, guvenlikGecerlilikTarihi, dil, ozId, sdp, heysk). BelgeNo is set later via PUT /jobs/{id}/eyp/metadata (D9, manual). (Phase 2) rehberVersion (\\\&quot;1.3\\\&quot; | \\\&quot;2.0\\\&quot;, default \\\&quot;2.0\\\&quot;) fixes the package format for the whole job and cannot be changed afterwards, so it must be decided here. An unsupported value fails the request with 400 EYP_UNSUPPORTED_VERSION.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsPost(accessToken: string, name: string, signingType?: string, eyp?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsPost(accessToken: string, name: string, signingType?: string, eyp?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsPost(accessToken: string, name: string, signingType?: string, eyp?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsPost(accessToken: string, name: string, signingType?: string, eyp?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsPost.');
        }
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling jobsPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (name !== undefined && name !== null) {
            localVarFormParams = localVarFormParams.append('name', <any>name) as any || localVarFormParams;
        }
        if (signingType !== undefined && signingType !== null) {
            localVarFormParams = localVarFormParams.append('signing_type', <any>signingType) as any || localVarFormParams;
        }
        if (eyp !== undefined && eyp !== null) {
            localVarFormParams = localVarFormParams.append('eyp', <any>eyp) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new job using existing public link and fill the empty fields using JSON data and prepare the job to sign.
     * @param code Code of public link
     * @param body JSON data for recipients and fields
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsPublicLinkCodeInitiatePost(code: string, body: object, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public jobsPublicLinkCodeInitiatePost(code: string, body: object, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public jobsPublicLinkCodeInitiatePost(code: string, body: object, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public jobsPublicLinkCodeInitiatePost(code: string, body: object, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling jobsPublicLinkCodeInitiatePost.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling jobsPublicLinkCodeInitiatePost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/public_link/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/initiate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new job using existing public link and send sign request to recipients
     * @param code Code of the public link
     * @param recipient1Name Name of the first recipient
     * @param recipient1Email Email of the first recipient
     * @param recipient1CitizenId CitizenId of the first recipient
     * @param recipient2Name Name of the second recipient
     * @param recipient2Email Email of the second recipient
     * @param recipient2CitizenId CitizenId of the second recipient
     * @param recipient3Name Name of the third recipient
     * @param recipient3Email Email of the third recipient
     * @param recipient3CitizenId CitizenId of the third recipient
     * @param recipient4Name Name of the fourth recipient
     * @param recipient4Email Email of the fourth recipient
     * @param recipient4CitizenId CitizenId of the fourth recipient
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsPublicLinkCodePost(code: string, recipient1Name: string, recipient1Email: string, recipient1CitizenId?: string, recipient2Name?: string, recipient2Email?: string, recipient2CitizenId?: string, recipient3Name?: string, recipient3Email?: string, recipient3CitizenId?: string, recipient4Name?: string, recipient4Email?: string, recipient4CitizenId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsPublicLinkCodePost(code: string, recipient1Name: string, recipient1Email: string, recipient1CitizenId?: string, recipient2Name?: string, recipient2Email?: string, recipient2CitizenId?: string, recipient3Name?: string, recipient3Email?: string, recipient3CitizenId?: string, recipient4Name?: string, recipient4Email?: string, recipient4CitizenId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsPublicLinkCodePost(code: string, recipient1Name: string, recipient1Email: string, recipient1CitizenId?: string, recipient2Name?: string, recipient2Email?: string, recipient2CitizenId?: string, recipient3Name?: string, recipient3Email?: string, recipient3CitizenId?: string, recipient4Name?: string, recipient4Email?: string, recipient4CitizenId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsPublicLinkCodePost(code: string, recipient1Name: string, recipient1Email: string, recipient1CitizenId?: string, recipient2Name?: string, recipient2Email?: string, recipient2CitizenId?: string, recipient3Name?: string, recipient3Email?: string, recipient3CitizenId?: string, recipient4Name?: string, recipient4Email?: string, recipient4CitizenId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling jobsPublicLinkCodePost.');
        }
        if (recipient1Name === null || recipient1Name === undefined) {
            throw new Error('Required parameter recipient1Name was null or undefined when calling jobsPublicLinkCodePost.');
        }
        if (recipient1Email === null || recipient1Email === undefined) {
            throw new Error('Required parameter recipient1Email was null or undefined when calling jobsPublicLinkCodePost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (recipient1Name !== undefined && recipient1Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient1Name', <any>recipient1Name) as any || localVarFormParams;
        }
        if (recipient1Email !== undefined && recipient1Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient1Email', <any>recipient1Email) as any || localVarFormParams;
        }
        if (recipient1CitizenId !== undefined && recipient1CitizenId !== null) {
            localVarFormParams = localVarFormParams.append('recipient1CitizenId', <any>recipient1CitizenId) as any || localVarFormParams;
        }
        if (recipient2Name !== undefined && recipient2Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient2Name', <any>recipient2Name) as any || localVarFormParams;
        }
        if (recipient2Email !== undefined && recipient2Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient2Email', <any>recipient2Email) as any || localVarFormParams;
        }
        if (recipient2CitizenId !== undefined && recipient2CitizenId !== null) {
            localVarFormParams = localVarFormParams.append('recipient2CitizenId', <any>recipient2CitizenId) as any || localVarFormParams;
        }
        if (recipient3Name !== undefined && recipient3Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient3Name', <any>recipient3Name) as any || localVarFormParams;
        }
        if (recipient3Email !== undefined && recipient3Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient3Email', <any>recipient3Email) as any || localVarFormParams;
        }
        if (recipient3CitizenId !== undefined && recipient3CitizenId !== null) {
            localVarFormParams = localVarFormParams.append('recipient3CitizenId', <any>recipient3CitizenId) as any || localVarFormParams;
        }
        if (recipient4Name !== undefined && recipient4Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient4Name', <any>recipient4Name) as any || localVarFormParams;
        }
        if (recipient4Email !== undefined && recipient4Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient4Email', <any>recipient4Email) as any || localVarFormParams;
        }
        if (recipient4CitizenId !== undefined && recipient4CitizenId !== null) {
            localVarFormParams = localVarFormParams.append('recipient4CitizenId', <any>recipient4CitizenId) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/public_link/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get smart status of jobs of the user
     * @param accessToken System access token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsSmartstatusGet(accessToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<SmartStatus>>;
    public jobsSmartstatusGet(accessToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<SmartStatus>>>;
    public jobsSmartstatusGet(accessToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<SmartStatus>>>;
    public jobsSmartstatusGet(accessToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsSmartstatusGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/smartstatus`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<SmartStatus>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new job using existing job template and up-to-date recipients
     * @param accessToken System access token
     * @param id ID of the job template
     * @param recipients Up-to-date recipients of job
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsSystemTemplateIdPost(accessToken: string, id: number, recipients: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsSystemTemplateIdPost(accessToken: string, id: number, recipients: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsSystemTemplateIdPost(accessToken: string, id: number, recipients: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsSystemTemplateIdPost(accessToken: string, id: number, recipients: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsSystemTemplateIdPost.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobsSystemTemplateIdPost.');
        }
        if (recipients === null || recipients === undefined) {
            throw new Error('Required parameter recipients was null or undefined when calling jobsSystemTemplateIdPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (recipients !== undefined && recipients !== null) {
            localVarFormParams = localVarFormParams.append('recipients', <any>recipients) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/system_template/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new job using existing job template
     * @param accessToken System access token
     * @param templateId ID of the job template
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsTemplateTemplateIdPost(accessToken: string, templateId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Job>;
    public jobsTemplateTemplateIdPost(accessToken: string, templateId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Job>>;
    public jobsTemplateTemplateIdPost(accessToken: string, templateId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Job>>;
    public jobsTemplateTemplateIdPost(accessToken: string, templateId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsTemplateTemplateIdPost.');
        }
        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling jobsTemplateTemplateIdPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/template/${this.configuration.encodeParam({name: "templateId", value: templateId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Job>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Apply template to jobs
     * @param accessToken System access token
     * @param templateId ID of the job template
     * @param jobs comman separated job list
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsTemplateTemplateIdPut(accessToken: string, templateId: number, jobs: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsTemplateTemplateIdPut(accessToken: string, templateId: number, jobs: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsTemplateTemplateIdPut(accessToken: string, templateId: number, jobs: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsTemplateTemplateIdPut(accessToken: string, templateId: number, jobs: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling jobsTemplateTemplateIdPut.');
        }
        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling jobsTemplateTemplateIdPut.');
        }
        if (jobs === null || jobs === undefined) {
            throw new Error('Required parameter jobs was null or undefined when calling jobsTemplateTemplateIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (jobs !== undefined && jobs !== null) {
            localVarFormParams = localVarFormParams.append('jobs', <any>jobs) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/template/${this.configuration.encodeParam({name: "templateId", value: templateId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the document content of the job of recipient request
     * @param code Code of the recipient request that was sent with email
     * @param pass Optional password for the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientRequestsCodeDownloadGet(code: string, pass?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public recipientRequestsCodeDownloadGet(code: string, pass?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public recipientRequestsCodeDownloadGet(code: string, pass?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public recipientRequestsCodeDownloadGet(code: string, pass?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling recipientRequestsCodeDownloadGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pass, 'pass');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/recipient_requests/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/download`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Provides fields configuration of the job documents by request code
     * @param code Request code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientRequestsCodeFieldsGet(code: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<DocumentField>>;
    public recipientRequestsCodeFieldsGet(code: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<DocumentField>>>;
    public recipientRequestsCodeFieldsGet(code: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<DocumentField>>>;
    public recipientRequestsCodeFieldsGet(code: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling recipientRequestsCodeFieldsGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipient_requests/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fields`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<DocumentField>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates field values for a recipient request.  IMPORTANT REQUIREMENTS: - Must send complete field objects with ALL properties (id, documentId, recipientId, type, etc.) - All fields marked with required&#x3D;true MUST be set before calling biosign - Field value types by field type:   * checkbox: value must be \&quot;true\&quot; or \&quot;false\&quot; (string, not boolean)   * radio: value must be \&quot;true\&quot; or \&quot;false\&quot; (string, not boolean) - set \&quot;true\&quot; for the selected radio button, \&quot;false\&quot; for all others in the group   * text-input: value must be a non-empty string if required&#x3D;true   * text-area: value must be a string   * bio-sign, sign-area, initials: set via /recipient_signatures endpoint, not this endpoint - For radio button groups: set value&#x3D;\&quot;true\&quot; for the ONE radio button to select (matching the desired selectedValue in options), and value&#x3D;\&quot;false\&quot; for all other radio buttons in the group - Returns 500 Internal Server Error if:   * Required fields are missing or invalid   * Radio buttons have invalid values (must be \&quot;true\&quot; or \&quot;false\&quot;)   * Field objects are missing required properties   * Multiple radio buttons in the same group have value&#x3D;\&quot;true\&quot; (only one can be selected) 
     * @param code Request code
     * @param fields Complete fields configuration in JSON format as array of field objects. Must send ALL field properties (id, documentId, recipientId, type, page, variable, value, etc.).  Value format by field type: - checkbox: \\\&quot;true\\\&quot; or \\\&quot;false\\\&quot; (string) - radio: \\\&quot;true\\\&quot; or \\\&quot;false\\\&quot; (string) - set \\\&quot;true\\\&quot; for selected radio button, \\\&quot;false\\\&quot; for others in group - text-input, text-area: string value - bio-sign, sign-area, initials: upload via /recipient_signatures, value managed by server  Example workflow: 1. GET /recipient_requests/{code}/fields to retrieve complete field objects (AN-1801: for a customize-sign-box QES signer, this array carries the recipient\\\&#39;\\\&#39;s single sign-area; PUT the same array back with its signer-chosen geometry x, y, width, height, page to place the box — the backend persists geometry and sets placed&#x3D;true. Exactly one sign-area, within page bounds, only while the recipient is WAITING.) 2. Update the \\\&quot;value\\\&quot; property for each field based on its type 3. PUT the complete modified array back to this endpoint 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientRequestsCodeFieldsPut(code: string, fields: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<DocumentField>>;
    public recipientRequestsCodeFieldsPut(code: string, fields: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<DocumentField>>>;
    public recipientRequestsCodeFieldsPut(code: string, fields: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<DocumentField>>>;
    public recipientRequestsCodeFieldsPut(code: string, fields: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling recipientRequestsCodeFieldsPut.');
        }
        if (fields === null || fields === undefined) {
            throw new Error('Required parameter fields was null or undefined when calling recipientRequestsCodeFieldsPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (fields !== undefined && fields !== null) {
            localVarFormParams = localVarFormParams.append('fields', <any>fields) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipient_requests/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fields`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<DocumentField>>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the job information with request code
     * @param code Code of the recipient request that was sent with email
     * @param pass Optional password for the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientRequestsCodeJobGet(code: string, pass?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JobOfCode>;
    public recipientRequestsCodeJobGet(code: string, pass?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JobOfCode>>;
    public recipientRequestsCodeJobGet(code: string, pass?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JobOfCode>>;
    public recipientRequestsCodeJobGet(code: string, pass?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling recipientRequestsCodeJobGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pass, 'pass');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipient_requests/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/job`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<JobOfCode>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the request content for the recipient.
     * @param code Code of the recipient request that was sent with email
     * @param operator Mobile signature operator
     * @param mobile Mobile number of the recipient
     * @param reason Reason for signing
     * @param location Location of signing
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientRequestsCodeMsignPost(code: string, operator: string, mobile: string, reason: string, location: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MsignResponse>;
    public recipientRequestsCodeMsignPost(code: string, operator: string, mobile: string, reason: string, location: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MsignResponse>>;
    public recipientRequestsCodeMsignPost(code: string, operator: string, mobile: string, reason: string, location: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MsignResponse>>;
    public recipientRequestsCodeMsignPost(code: string, operator: string, mobile: string, reason: string, location: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling recipientRequestsCodeMsignPost.');
        }
        if (operator === null || operator === undefined) {
            throw new Error('Required parameter operator was null or undefined when calling recipientRequestsCodeMsignPost.');
        }
        if (mobile === null || mobile === undefined) {
            throw new Error('Required parameter mobile was null or undefined when calling recipientRequestsCodeMsignPost.');
        }
        if (reason === null || reason === undefined) {
            throw new Error('Required parameter reason was null or undefined when calling recipientRequestsCodeMsignPost.');
        }
        if (location === null || location === undefined) {
            throw new Error('Required parameter location was null or undefined when calling recipientRequestsCodeMsignPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (operator !== undefined && operator !== null) {
            localVarFormParams = localVarFormParams.append('operator', <any>operator) as any || localVarFormParams;
        }
        if (mobile !== undefined && mobile !== null) {
            localVarFormParams = localVarFormParams.append('mobile', <any>mobile) as any || localVarFormParams;
        }
        if (reason !== undefined && reason !== null) {
            localVarFormParams = localVarFormParams.append('reason', <any>reason) as any || localVarFormParams;
        }
        if (location !== undefined && location !== null) {
            localVarFormParams = localVarFormParams.append('location', <any>location) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipient_requests/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/msign`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MsignResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a recipient from a job.  **Workflow Context:** This endpoint allows removing recipients from a job during the preparation phase: 1. Start request signature: PUT /jobs/{id}/actions/startrequestsignature 2. Add recipients: POST /jobs/{id}/recipients 3. **Remove unwanted recipient: DELETE /recipients/{id}** (this endpoint) 4. Continue with other recipients and finish  **Prerequisites:** - Recipient must exist - Job must be in DRAFT status (recipients can only be removed before finishing) - User must be the job owner  **Important Notes:** - You cannot delete the last recipient from a job - The requesting user (job owner) is automatically added as the first recipient when calling startrequestsignature - Once the job is finished (PUT /jobs/{id}/actions/finish), recipients cannot be removed  **Common Use Cases:** - Remove incorrectly added recipients - Simplify recipient list before finishing the job - Replace a recipient (delete old one, add new one) 
     * @param accessToken System access token
     * @param id id of the recipient
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientsIdDelete(accessToken: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public recipientsIdDelete(accessToken: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public recipientsIdDelete(accessToken: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public recipientsIdDelete(accessToken: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling recipientsIdDelete.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipientsIdDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipients/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an existing recipient\&#39;s information, role, or workflow effect.  **Workflow Context:** This endpoint is used after adding a recipient to modify their properties: 1. Add recipient: POST /jobs/{id}/recipients (creates with default SIGNER/REQUIRED) 2. **Update recipient: PUT /recipients/{id}** (this endpoint - change role/workflow_effect)  **What can be updated:** - Basic information: name, email, citizen_id, phone_number, sms_country_code - Role: Change between SIGNER, VIEWER, or COPY - Workflow effect: Change between REQUIRED or OPTIONAL  **Recipient Roles:** - SIGNER: Can sign documents (default when created) - VIEWER: Can view documents but not sign - COPY: Receives copy of completed documents  **Workflow Effects:** - REQUIRED: Recipient must complete their action for workflow to proceed (default when created) - OPTIONAL: Workflow can proceed without this recipient\&#39;s action  **Prerequisites:** - Recipient must exist - Job must be in DRAFT status - User must be the job owner  **Common Use Cases:** - Change a recipient from SIGNER to VIEWER if they only need to review - Change workflow_effect to OPTIONAL for recipients whose action is not mandatory - Update contact information (email, phone) before sending notifications 
     * @param accessToken System access token
     * @param id id of the recipient
     * @param name Recipient full name
     * @param email Recipient email
     * @param citizenId Citizen ID
     * @param role Recipient role. signer, viewer, copy
     * @param workflowEffect Recipient workflow effect. required, optional
     * @param phoneNumber Recipient phone number
     * @param smsCountryCode Recipient phone number country code
     * @param signMethod Explicit signing method. One of qes (qualified e-signature), bio (biometric), initials. If omitted, the existing value is left unchanged.
     * @param canCustomizeSignBox AN-1801: when true, this QES signer places/customizes their own single signature box during signing (the sender may not place it). Accepted only for role SIGNER with sign_method qes; otherwise 400 (302). Sent as boolean true/false.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientsIdPut(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public recipientsIdPut(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public recipientsIdPut(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public recipientsIdPut(accessToken: string, id: number, name: string, email: string, citizenId?: string, role?: string, workflowEffect?: string, phoneNumber?: string, smsCountryCode?: string, signMethod?: string, canCustomizeSignBox?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling recipientsIdPut.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipientsIdPut.');
        }
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling recipientsIdPut.');
        }
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling recipientsIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (name !== undefined && name !== null) {
            localVarFormParams = localVarFormParams.append('name', <any>name) as any || localVarFormParams;
        }
        if (email !== undefined && email !== null) {
            localVarFormParams = localVarFormParams.append('email', <any>email) as any || localVarFormParams;
        }
        if (citizenId !== undefined && citizenId !== null) {
            localVarFormParams = localVarFormParams.append('citizen_id', <any>citizenId) as any || localVarFormParams;
        }
        if (role !== undefined && role !== null) {
            localVarFormParams = localVarFormParams.append('role', <any>role) as any || localVarFormParams;
        }
        if (workflowEffect !== undefined && workflowEffect !== null) {
            localVarFormParams = localVarFormParams.append('workflow_effect', <any>workflowEffect) as any || localVarFormParams;
        }
        if (phoneNumber !== undefined && phoneNumber !== null) {
            localVarFormParams = localVarFormParams.append('phone_number', <any>phoneNumber) as any || localVarFormParams;
        }
        if (smsCountryCode !== undefined && smsCountryCode !== null) {
            localVarFormParams = localVarFormParams.append('sms_country_code', <any>smsCountryCode) as any || localVarFormParams;
        }
        if (signMethod !== undefined && signMethod !== null) {
            localVarFormParams = localVarFormParams.append('sign_method', <any>signMethod) as any || localVarFormParams;
        }
        if (canCustomizeSignBox !== undefined && canCustomizeSignBox !== null) {
            localVarFormParams = localVarFormParams.append('can_customize_sign_box', <any>canCustomizeSignBox) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipients/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get template by job ID
     * @param accessToken System access token
     * @param jobId Job ID associated with the template
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public templateGet(accessToken: string, jobId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Template>;
    public templateGet(accessToken: string, jobId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Template>>;
    public templateGet(accessToken: string, jobId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Template>>;
    public templateGet(accessToken: string, jobId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling templateGet.');
        }
        if (jobId === null || jobId === undefined) {
            throw new Error('Required parameter jobId was null or undefined when calling templateGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/templates/${this.configuration.encodeParam({name: "jobId", value: jobId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Template>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new job template for the user
     * @param accessToken System access token
     * @param jobId ID of the template job
     * @param category Template category. Default: all
     * @param definition Template definition.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public templateJobIdPost(accessToken: string, jobId: number, category?: string, definition?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Template>;
    public templateJobIdPost(accessToken: string, jobId: number, category?: string, definition?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Template>>;
    public templateJobIdPost(accessToken: string, jobId: number, category?: string, definition?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Template>>;
    public templateJobIdPost(accessToken: string, jobId: number, category?: string, definition?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling templateJobIdPost.');
        }
        if (jobId === null || jobId === undefined) {
            throw new Error('Required parameter jobId was null or undefined when calling templateJobIdPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (category !== undefined && category !== null) {
            localVarFormParams = localVarFormParams.append('category', <any>category) as any || localVarFormParams;
        }
        if (definition !== undefined && definition !== null) {
            localVarFormParams = localVarFormParams.append('definition', <any>definition) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/template/${this.configuration.encodeParam({name: "jobId", value: jobId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Template>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all templates
     * @param accessToken System access token
     * @param type Template type. Possible values are \&quot;user\&quot; and \&quot;system\&quot;. Default: user
     * @param category Template category. Default: all
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public templatesGet(accessToken: string, type?: string, category?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Template>>;
    public templatesGet(accessToken: string, type?: string, category?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Template>>>;
    public templatesGet(accessToken: string, type?: string, category?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Template>>>;
    public templatesGet(accessToken: string, type?: string, category?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling templatesGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>type, 'type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>category, 'category');

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/templates`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Template>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all template jobs of the user
     * @param accessToken System access token
     * @param type Template type. Possible values are \&quot;user\&quot; and \&quot;system\&quot;. Default: user
     * @param category Template category. Default: all
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public templatesJobsGet(accessToken: string, type?: string, category?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JoblistResult>;
    public templatesJobsGet(accessToken: string, type?: string, category?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JoblistResult>>;
    public templatesJobsGet(accessToken: string, type?: string, category?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JoblistResult>>;
    public templatesJobsGet(accessToken: string, type?: string, category?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling templatesJobsGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>type, 'type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>category, 'category');

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/templates/jobs`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<JoblistResult>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
